





















































import { mapActions } from 'vuex'
import XForm from '@/components/atoms/Form/XForm.vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XPasswordInput from '@/components/atoms/Input/XPasswordInput.vue'
import { UpdatePasswordInput } from '@/types/generated/graphql'
import toastMixin from '@/mixin/toastMixin'

type DataType = { input: UpdatePasswordInput & { newPasswordConfirm: string } }

export default toastMixin.extend({
  name: 'UpdatePassword',
  components: { XForm, XButton, XPasswordInput },
  data(): DataType {
    return {
      input: {
        currentPassword: '',
        newPassword: '',
        newPasswordConfirm: '',
      },
    }
  },
  methods: {
    ...mapActions('auth', ['updatePassword']),
    async handleSend() {
      const { newPasswordConfirm, ...rest } = this.input
      await this.updatePassword(rest).then(() => {
        this.showToast(this.$tc('updatepassword.updateSuccess'))
      })
    },
  },
})
